
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.292 24.273h8.165a2.58 2.58 0 011.83.761c.471.47.762 1.118.762 1.83v15.433a2.58 2.58 0 01-.761 1.83c-.47.471-1.118.762-1.831.762H9.292a2.58 2.58 0 01-1.831-.761 2.583 2.583 0 01-.762-1.831V26.865c0-.713.291-1.363.762-1.831a2.583 2.583 0 011.83-.761zm8.165 1.265H9.292c-.365 0-.696.15-.937.39-.24.24-.39.572-.39.937v15.432c0 .365.15.696.39.937.24.24.572.39.937.39h8.165c.365 0 .696-.15.937-.39.24-.24.39-.572.39-.937V26.865c0-.365-.15-.696-.39-.937-.24-.24-.572-.39-.937-.39z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.026 25.629a.63.63 0 00.543 1.137c.025-.013 8.686-4.027 7.418-16.43 1.753-.32 7.368-.447 4.934 11.884a.632.632 0 00.755.74c1.042-.132 17.358-2.11 12.136 5.896l-.003-.002a.634.634 0 00.064.772c.238.31 2.048 2.825-.831 4.225h-.003a.63.63 0 00-.314.793c.087.258 1.034 3.26-1.192 4.213h-.002a.634.634 0 00-.381.639c-.005.521-.142 4.715-3.688 4.231v-.002a.754.754 0 00-.097-.006H22.973l-3.272-1.8a.632.632 0 10-.61 1.108l3.382 1.86a.631.631 0 00.338.098h15.541c4.369.552 4.964-3.782 5.042-5.147 2.28-1.253 1.93-3.962 1.662-5.1 3.075-1.806 1.685-4.567 1.038-5.561 5.416-8.877-9.037-7.94-12.779-7.56C35.99 6.484 26.78 9.04 26.14 9.235a.637.637 0 00-.476.692c1.478 11.935-6.622 15.685-6.645 15.697l.008.005z","fill":"currentColor"}})])
          )
        }
      }
    